export const english = {
  lang: 'en',
  data: {
    titles: {
      course: 'Course',
      about_course: 'About this Course',
      target_group: 'Target Group',
      course_content: 'Course Content',
      course_images: 'Images',
      practical_information: 'Pratical information',
      curriculum: 'Curriculum',
      place: 'Place',
      meetup_place: 'Meetup place',
      select_start_date: 'Select Date',
      select_start_date_first: 'Select Date First',
      selected_timeslot: 'Select Timeslot',
      payment: 'Participant',
      date: 'Date',
      participants_number: 'Number of participants',
      customer_info: 'Customer information',
      participant: 'Participant',
      participant_phone_help_message: 'We will look for participant by this phone number.',
      select_date_time: 'Select Date and Time'
    },
    reviews: 'Reviews',
    read_more_reviews: 'Read more reviews',
    no_available_seats: 'No available seats',
    sold_out: 'Sold out',
    free_seat: 'free seat',
    free_seats: 'free seats',
    more_free_seats: 'or more free seats',
    signup_deadline_passed: 'Signup deadline passed',
    time_zone_info: 'Times are shown in local time, please be aware if you are in a different time zone.',
    rs_member: 'RS-member',
    rs_non_member: 'Price',
    become_rs_member: 'Become an RS-member',
    course_days: 'Number of course days',
    day: 'Day',
    days: 'Days',
    check_multi_participant: "Are you buying the course for {{ count }} other person(s)?",
    select_participant: "Select the number of participants",
    self_participant: 'Are you going to sign up for the course?',
    participant_form: {
      labels: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone'
      },
      placeholders: {
        name: 'Enter the name of the person who will receive the course',
        email: 'Enter an email to the person who will receive the course',
        phone: 'Enter the telephone number of the person who will receive the course'
      },
      validations: {
        name: {
          required: 'Name of the participant is required'
        },
        email: {
          required: 'Email of the participant is required.',
          email: 'This looks like an invalid email address. Are you sure it is spelled correctly?',
        },
        phone: {
          required: 'Phone number of participant is required.',
          pattern: 'Please use number only when providing your phonenumber.',
          length: 'Provided phone number is not valid.'
        }
      },
      participant_phone_help_message: 'We will look for existing RS Sjøliv users by this phone number. If nothing appears, also enter the participant\'s name and email.',
      participant_email_help_message: 'Remember that the email address must be the same as the one (you or the person you buy the course for) logs in/registers with to gain access to the course.',
      submit_form: 'Complete Payment'
    },
    action_buttons: {
      back: 'Back',
      buy: 'Buy',
      see_more_dates: 'See more dates',
      login_required: 'Login or register'
    }
  },
};
